import React, { useContext, useEffect, useState } from "react";
import { Context } from "../index";
import { editPosting, getPosting } from "../http/userAPI";
import { useParams } from "react-router-dom";
import { Button, Form, Modal, Row, Table } from "react-bootstrap";
import { RiShoppingBasketFill } from "react-icons/ri";
import { observer } from "mobx-react-lite";
import ProductItem from "../components/ProductItem";

const PostingPage = observer(() => {
  const { user, product } = useContext(Context);
  const { postingNumber } = useParams();

  const [posting, setPosting] = useState({ products: [] });
  const [localReload, setLocalReload] = useState(1);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getPosting(user, postingNumber).then(data => setPosting(data));
  }, [product.reload]);

/*  const handleSearchChange = (e) => {
    product.resetFilters();
    product.setSelectedFolder({
      id: "f7f487a6-8257-11eb-0a80-0011000ac16e",
      name: "Сплит-системы настенные",
    });
    product.setPaginationPage(1);
    product.setSearch(e.target.value);
  };*/

  const handleCountChange = (productItem, delta) => {
    productItem.count += delta;
    setLocalReload(localReload + 1);
  };

  const handleRemoveProduct = (article) => {
    posting.products = posting.products.filter(pr => pr.article !== article);
    setLocalReload(localReload + 1);
  };

  const handleSave = () => {
    editPosting(user.user, posting);
    appendAlert("Товары успешно обновлены", "success");
  };

  // 
  const appendAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("liveAlertPlaceholder");
    const wrapper = document.createElement("div");
    wrapper.innerHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <div>${message}</div>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `;
    alertPlaceholder.append(wrapper);
  };

  return (
    <div className="container">
      {/* Alert */}
      <div id="liveAlertPlaceholder"></div>

      {/* Title */}
      <div className="py-5 text-center">
        <h2>Заказ {posting.number}</h2>
      </div>

      {/* Product Modal */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Добавить товар</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form role="search">
            <Form.Control
              className="me-2 rounded-4 mb-3"
              type="search"
              placeholder="Найти, например MSAG1-07HRN1..."
              value={product.search}
            /*  onChange={handleSearchChange} */
            />
            {product.search !== "" && (
              <Row className="d-flex">
                {product.products.map(productItem => (
                  <ProductItem
                    key={productItem.id}
                    productItem={productItem}
                    modal={true}
                    handleClose={handleClose}
                  />
                ))}
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Закрыть</Button>
        </Modal.Footer>
      </Modal>

      {/* Product Table */}
      <h4 className="mb-3">Товары</h4>
      <div className="table-responsive">
        <Table hover size="sm">
          <thead>
            <tr>
              <th>Товар</th>
              <th>Артикул</th>
              <th>Стоимость</th>
              <th>Количество</th>
            </tr>
          </thead>
          <tbody>
            {posting.products.map((productItem, index) => (
              <tr key={index}>
                <td>{productItem.name}</td>
                <td>{productItem.article}</td>
                <td>{productItem.price}</td>
                <td>
                  <Button
                    variant="secondary"
                    className="btn-controller mx-2 rounded-4"
                    disabled={productItem.count <= 1}
                    onClick={() => handleCountChange(productItem, -1)}
                  >
                    -
                  </Button>
                  &nbsp;{productItem.count}&nbsp;
                  <Button
                    variant="secondary"
                    className="btn-controller mx-2 rounded-4"
                    onClick={() => handleCountChange(productItem, 1)}
                  >
                    +
                  </Button>
                  &nbsp;
                  {posting.products.length > 1 && (
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => handleRemoveProduct(productItem.article)}
                    >
                      <RiShoppingBasketFill />
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {localReload > 1 && (
          <Button variant="warning" className="me-2" onClick={handleSave}>
            Сохранить
          </Button>
        )}
        <Button variant="primary" onClick={handleShow}>Добавить товар</Button>
      </div>

      {/* Posting Info */}
      <div className="row g-3 mt-4">
      {user.hasRoleShop && (
        <div className="col-sm-4">
          <h5>Покупатель</h5>
          <p>{posting.customer}</p>
        </div>)}
        <div className="col-sm-4">
          <h5>Получатель</h5>
          <p>{posting.addressee}</p>
        </div>
        <div className="col-sm-4">
          <h5>Телефон</h5>
          <a href={`tel:${posting.phone}`}>{posting.phone}</a>
        </div>
        <div className="col-12">
          <h5>Адрес доставки</h5>
          <p>{posting.address}</p>
        </div>
        <div className="col-4">
          <h5>Статус</h5>
          <p>{posting.status}</p>
        </div>
        <div className="col-4">
          <h5>Принят в обработку</h5>
          <p>{posting.date}</p>
        </div>
        {posting.shipmentDate && (
          <div className="col-4">
            <h5>Дата отгрузки</h5>
            <p>{posting.shipmentDate}</p>
          </div>
        )}
      </div>
    </div>
  );
});

export default PostingPage;
